const creditsES = {
    "view": {
        "form": {
            "title": "Ordenar Créditos",
            "label": {
                "quantity": "Cantidad"
            },
            "placeholder": {
                "quantity": "Seleccionar Cantidad"
            },
            "help_text": {
                "quantity": "Cantidad de créditos que deseas ordenar."
            },
            "button": {
                "placeOrder": "Realizar Pedido"
            },
            "options": {
                "quantity": {
                    "selectQuantity": "Seleccionar Cantidad",
                    "1Credit": "1 Crédito",
                    "2Credits": "2 Créditos",
                    "3Credits": "3 Créditos",
                    "4Credits": "4 Créditos",
                    "5Credits": "5 Créditos",
                    "10Credits": "10 Créditos",
                    "15Credits": "15 Créditos",
                    "20Credits": "20 Créditos",
                    "25Credits": "25 Créditos",
                    "30Credits": "30 Créditos",
                    "35Credits": "35 Créditos",
                    "40Credits": "40 Créditos",
                    "45Credits": "45 Créditos",
                    "50Credits": "50 Créditos",
                    "75Credits": "75 Créditos",
                    "100Credits": "100 Créditos"
                }
            },
            "message": {
                "quantityRequired": "La cantidad es requerida",
                "paymentMethodRequired": "Por favor añade un <1>método de pago</1> para realizar el pedido de créditos.",
                "paymentMethodExpired": "No puedes realizar el pedido de créditos ya que tu <1>método de pago</1> predeterminado ha expirado, por favor establece un método de pago válido como predeterminado para realizar el pedido de créditos."
            }
        },
        "modal": {
            "header": "Proceder al pago",
            "body": {
                "message": "Has ordenado {{credits}} Créditos",
                "confirmationMessage": "Si deseas confirmar el pedido, por favor procede al pago, de lo contrario puedes cancelar el pedido."
            },
            "button": {
                "cancel": "Cancelar",
                "checkout": "Pagar"
            }
        },
        "message": {
            "error": "¡Algo salió mal! Por favor actualiza la página e inténtalo de nuevo."
        }
    },
    "transactionSuccess": {
        "view": {
            "title": "Transacción Exitosa :)",
            "description": "¡Has comprado los créditos exitosamente y se añadirán a tu cuenta en breve!",
            "button": {
                "returnToDashboard": "Volver al Panel"
            }
        }
    },
    "transactionFailure": {
        "view": {
            "title": "Transacción Cancelada :(",
            "description": "La transacción fue cancelada... ¡Por favor intenta de nuevo más tarde!",
            "button": {
                "returnToDashboard": "Volver al Panel"
            }
        }
    }
};

export default creditsES;